(function () {
  'use strict';

  /* ── Fields that need validation ── */
  var NAME_FIELDS = [
    'address[first_name]', 'address[last_name]',
    'customer[first_name]', 'customer[last_name]'
  ];
  var ADDRESS_FIELDS = ['address[address1]'];
  var CITY_FIELDS    = ['address[city]'];
  var PINCODE_FIELDS = ['address[zip]'];
  var PHONE_FIELDS   = ['address[phone]'];
  var EMAIL_FIELDS   = ['customer[email]'];
  var PASSWORD_FIELDS = ['customer[password]'];
  var PASSWORD_CONFIRM_FIELDS = ['customer[password_confirmation]'];

  function isIn(arr, val) { return arr.indexOf(val) !== -1; }

  /* ── Validate a single field – returns error string or '' ── */
  function validateField(field) {
    var name  = field.getAttribute('name');
    var value = field.value.trim();

    /* --- Name fields (first_name, last_name) --- */
    if (isIn(NAME_FIELDS, name)) {
      if (value === '') return 'Name is required';
      if (!/^[A-Za-z\s]+$/.test(value)) return 'Name must contain only letters';
      if (value.length < 2 || value.length > 50) return 'Name must be between 2–50 characters';
      return '';
    }

    /* --- Address --- */
    if (isIn(ADDRESS_FIELDS, name)) {
      if (value === '') return 'Address is required';
      if (!/^[A-Za-z0-9\s,\-\/]+$/.test(value)) return 'Please enter a valid address';
      if (value.length < 10) return 'Address must be at least 10 characters';
      if (value.length > 200) return 'Please enter a valid address';
      return '';
    }

    /* --- City --- */
    if (isIn(CITY_FIELDS, name)) {
      if (value === '') return 'City is required';
      if (!/^[A-Za-z\s]+$/.test(value)) return 'City must contain only letters';
      if (value.length < 2 || value.length > 100) return 'Enter a valid city name';
      return '';
    }

    /* --- Pincode (India – 6 digits) --- */
    if (isIn(PINCODE_FIELDS, name)) {
      if (value === '') return 'Pincode is required';
      if (!/^\d+$/.test(value)) return 'Enter valid 6-digit pincode';
      if (value.length !== 6) return 'Enter valid 6-digit pincode';
      return '';
    }

    /* --- Phone Number (India – 10 digits starting with 6-9) --- */
    if (isIn(PHONE_FIELDS, name)) {
      if (value === '') return 'Phone number is required';
      if (!/^\d+$/.test(value)) return 'Enter valid 10-digit mobile number';
      if (!/^[6-9]/.test(value)) return 'Phone number must start with 6,7,8, or 9';
      if (value.length !== 10) return 'Enter valid 10-digit mobile number';
      return '';
    }

    /* --- Email --- */
    if (isIn(EMAIL_FIELDS, name)) {
      if (value === '') return 'Email is required';
      if (/\s/.test(value)) return 'Invalid email format';
      if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(value)) return 'Enter valid email address';
      return '';
    }

    /* --- Password --- */
    if (isIn(PASSWORD_FIELDS, name)) {
      if (value === '') return 'Password is required';
      if (value.length < 8) return 'Password must be at least 8 characters';
      if (!/[A-Z]/.test(value) || !/[0-9]/.test(value) || !/[^A-Za-z0-9]/.test(value)) {
        return 'Include uppercase, number & special character';
      }
      return '';
    }

    /* --- Password confirmation --- */
    if (isIn(PASSWORD_CONFIRM_FIELDS, name)) {
      if (value === '') return 'Password confirmation is required';
      if (value.length < 8) return 'Password must be at least 8 characters';
      var form = field.closest('form');
      if (form) {
        var pwField = form.querySelector('input[name="customer[password]"]');
        if (pwField && pwField.value !== value) {
          return 'Passwords do not match';
        }
      }
      return '';
    }

    return '';
  }

  /* ── Show / clear inline error below a field ── */
  function showFieldError(field, message) {
    var wrapper = field.closest('.form-field');
    if (!wrapper) return;
    var errorEl = wrapper.querySelector('.customer-field-error');

    if (message) {
      field.classList.add('input--error');
      wrapper.classList.add('form-field--error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'customer-field-error';
        wrapper.appendChild(errorEl);
      }
      errorEl.textContent = message;
    } else {
      field.classList.remove('input--error');
      wrapper.classList.remove('form-field--error');
      if (errorEl) errorEl.remove();
    }
  }

  /* ── All field names that should be validated ── */
  var ALL_VALIDATED = [].concat(
    NAME_FIELDS, ADDRESS_FIELDS, CITY_FIELDS,
    PINCODE_FIELDS, PHONE_FIELDS, EMAIL_FIELDS,
    PASSWORD_FIELDS, PASSWORD_CONFIRM_FIELDS
  );

  /* ── Bind validation to a form ── */
  function initForm(form) {
    if (form.dataset.customerValidationBound) return;
    form.dataset.customerValidationBound = 'true';

    var fields = form.querySelectorAll('input[name], select[name]');
    var validatedFields = [];

    fields.forEach(function (field) {
      var name = field.getAttribute('name');
      if (ALL_VALIDATED.indexOf(name) === -1) return;
      validatedFields.push(field);

      field.addEventListener('blur', function () {
        showFieldError(field, validateField(field));
      });
      field.addEventListener('input', function () {
        if (field.classList.contains('input--error')) {
          showFieldError(field, validateField(field));
        }
      });
    });

    /* Submit gate – do not submit until every field is valid */
    form.addEventListener('submit', function (e) {
      var hasError = false;
      validatedFields.forEach(function (field) {
        var msg = validateField(field);
        showFieldError(field, msg);
        if (msg) hasError = true;
      });
      if (hasError) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var firstErr = form.querySelector('.form-field--error');
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ── Bootstrap ── */
  function init() {
    // Address forms
    document.querySelectorAll('form[action*="/addresses"], form[action*="/account"]').forEach(initForm);

    // Login / register forms (including sidebar .auth-form-2)
    document.querySelectorAll('.customer-login-form, .create-customer-form, .auth-form-2, form[action*="customer_login"], form[action*="create_customer"]').forEach(initForm);

    // Activate account / reset password forms
    document.querySelectorAll('form[action*="activate"], form[action*="reset"]').forEach(initForm);

    // Catch any remaining customer forms
    document.querySelectorAll('[data-customer-addresses] form').forEach(initForm);

    // MutationObserver for dynamically added forms
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              var forms = node.querySelectorAll ? node.querySelectorAll('form') : [];
              forms.forEach(function (f) {
                var action = f.getAttribute('action') || '';
                if (action.indexOf('/addresses') > -1 || action.indexOf('/account') > -1 || f.classList.contains('auth-form-2')) {
                  initForm(f);
                }
              });
              if (node.matches && node.matches('form')) {
                var a = node.getAttribute('action') || '';
                if (a.indexOf('/addresses') > -1 || a.indexOf('/account') > -1 || node.classList.contains('auth-form-2')) {
                  initForm(node);
                }
              }
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();